import React, { useState } from 'react';
import {deleteTemplateMailing} from "../auth";
import ConfirmationModal from "./ConfirmationModal";

interface TemplateMailing {
    id: number;
    libelle: string;
    type: string;
}

interface TemplateMailingTableProps {
    templateMailing: TemplateMailing[];
    onEditTemplateMailing: (templateMailing: TemplateMailing) => void;
    refreshTemplateMailing: () => void;
}

const TemplateMailingTable: React.FC<TemplateMailingTableProps> = ({ templateMailing, onEditTemplateMailing, refreshTemplateMailing }) => {
    const [filter, setFilter] = useState('');
    const [selectedTemplateMailing, setSelectedTemplateMailing] = useState<number[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [templateMailingToDelete, setTemplateMailingToDelete] = useState<TemplateMailing | null>(null);

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value);
    };

    const openModal = (templateMailing: TemplateMailing) => {
        setTemplateMailingToDelete(templateMailing);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setTemplateMailingToDelete(null);
    };

    const confirmDelete = async () => {
        if (templateMailingToDelete) {
            try {
                await deleteTemplateMailing(templateMailingToDelete.id);
                refreshTemplateMailing();
            } catch (error) {
                console.error('Erreur lors de la suppression du modèle de mail:', error);
            } finally {
                closeModal();
            }
        }
    };

    const handleDeleteSelected = async () => {
        try {
            await Promise.all(selectedTemplateMailing.map(templateMailingId => deleteTemplateMailing(templateMailingId)));
            refreshTemplateMailing();
            setSelectedTemplateMailing([]);
        } catch (error) {
            console.error('Erreur lors de la suppression des modèles de mail sélectionnés:', error);
        }
    };

    const filteredTemplateMailing = templateMailing.filter(
        (user) => user.libelle.includes(filter.toLowerCase())
    );

    const handleSelectTemplateMailing = (templateMailingId: number) => {
        setSelectedTemplateMailing((prevSelected) =>
            prevSelected.includes(templateMailingId)
                ? prevSelected.filter((id) => id !== templateMailingId)
                : [...prevSelected, templateMailingId]
        );
    };

    return (
        <div className="bg-white p-4 rounded-lg shadow-md">
            <div className="mb-4">
                <input
                    type="text"
                    placeholder="Filtrer par email"
                    className="p-2 border rounded-md w-full"
                    value={filter}
                    onChange={handleFilterChange}
                />
            </div>
            <table className="w-full table-auto">
                <thead>
                <tr>
                    <th className="px-4 py-2 text-center w-12">
                        <input
                            type="checkbox"
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedTemplateMailing(templateMailing.map((templateMailing) => templateMailing.id));
                                } else {
                                    setSelectedTemplateMailing([]);
                                }
                            }}
                            checked={selectedTemplateMailing.length === templateMailing.length}
                        />
                    </th>
                    <th className="px-4 py-2 text-center w-20">Identifiant</th>
                    <th className="px-4 py-2 text-center w-40">libelle</th>
                    <th className="px-4 py-2 text-center w-60">type</th>
                    <th className="px-4 py-2 text-center w-32">Actions</th>
                </tr>
                </thead>
                <tbody>
                {filteredTemplateMailing.map((templateMail) => (
                    <tr key={templateMail.id}>
                        <td className="px-4 py-2 text-center " >
                            <input
                                type="checkbox"
                                checked={selectedTemplateMailing.includes(templateMail.id)}
                                onChange={() => handleSelectTemplateMailing(templateMail.id)}
                            />
                        </td>
                        <td className="px-4 py-2 text-center ">{templateMail.id}</td>
                        <td className="px-4 py-2 text-center ">{templateMail.libelle}</td>
                        <td className="px-4 py-2 text-center ">{templateMail.type}</td>
                        <td className="px-4 py-2 text-center " >
                            <button
                                onClick={() => onEditTemplateMailing(templateMail)}
                                className="bg-green-500 text-white px-2 py-1 rounded-md mr-2"
                                title={'Modifier les informations utilisateurs'}
                            >
                                <i className={'fas fa-pen-to-square text-medium'}></i>
                            </button>
                            <button
                                onClick={() => openModal(templateMail)}
                                className="bg-red-500 text-white px-2 py-1 rounded-md"
                                title={'Supprimer le modèle de mail'}
                            >
                                <i className={'fas fa-trash-can text-medium'}></i>
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            {selectedTemplateMailing.length > 0 && (
                <div className="mt-4 text-left ">
                    <button
                        onClick={handleDeleteSelected}
                        className="bg-red-500 text-white px-4 py-2 rounded-md"
                        title={'Supprimer la sélection'}
                    >
                        <i className={'fas fa-trash-can text-xl'}></i>
                    </button>
                </div>
            )}
            <ConfirmationModal
                isOpen={isModalOpen}
                onClose={closeModal}
                onConfirm={confirmDelete}
                message={`Êtes-vous sûr de vouloir supprimer le modèle de mail "${templateMailingToDelete?.libelle}" ?`}
            />
        </div>
    );
};


export default TemplateMailingTable;
